import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

enum CustomerAccountStatus {
  Active = 0,
  Closed = 1,
}

enum AccountType {
  SingleAccount = 0,
  SubAccount = 1,
  GroupAccount = 2,
}

enum CustomerGender {
  None = 0,
  Male = 1,
  Female = 2,
}

export default {
  name: 'customerDetails',
    components: {
      DataGridComp: require('../../customcontrols/datagrid.vue').default,
      AttachmentsComp: require('./customerAttachements.vue').default,
      EventLogComp: require('./customerEventLog/customerEventLog.vue').default,
      ImagesComp: require('./customerImages.vue').default,
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
      CustomerCustomFields: require('@/employee/enquiries/customerCustomFields/customerCustomFields.vue').default,
      CustomerApplication: require('@/employee/enquiries/customerDetailsApplications/customerDetailsApplications.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      showmapDialog: true,
      menuVisible: true, 
      empName: "",
      lang: '',
      CUSTKEY: '',
      selectedTab: 'general', 
      scrollAmt: 200,
      tabs: [],
      accountTypeList: [
        { index: 0, Text: this.$t('enquiriesCustomerDetails.individualAccount') },
        { index: 1, Text: this.$t('enquiriesCustomerDetails.companyAccount') }
      ],
      billingGroupList: [],
      consumerTypeList: [],
      statementDeliveryTypes: [],
      statementDeliveryTypeSelected: 0,
      addressTypeList: [
        { index: 0, Text: this.$t('enquiriesCustomerDetails.codedAddress') },
        { index: 1, Text: this.$t('enquiriesCustomerDetails.uncodedAddress') }
      ],
      paymentType: [
        { index: null, Text: '' },
        { index: 0, Text: this.$t('enquiriesCustomerDetails.bankTransfer') },
        { index: 1, Text: this.$t('enquiriesCustomerDetails.directDebit') },
        { index: 2, Text: this.$t('common.Other') }
      ],

      customerId: 0,
      accountType: 0,
      BillingGroupTitle: '',
      billGroup: '',
      consumerType: '',
      oldAccountNo: '',
      accountStatus: '',
      surname: '',
      companyName: '',
      title: '',
      gender: '',
      firstName: '',
      telephoneNo: '',
      workTelephoneNo: '',
      comTelephoneNo: '',
      cellTelephoneNo: '',
      noSms: false,
      compCellTelephoneNo: '',
      compNoSms: false,
      custEmail: '',
      compFaxNo: '',
      applicantName: '',
      applicantTelephoneNo: '',
      employer: '',
      employerTelephoneNo: '',
      registrationNo: '',
      compEmail: '',
      faxNo: '',
      taxNo: '',
      addEmail: '',
      idNo: '',
      pin: '',
      birthDate: null,
      birthDateChecked: false,
      addressType: 0,
      addressTypeDisplay: 0,
      addressTitle1: '',
      addressTitle2: '',
      addressTitle3: '',
      addressTitle4: '',
      addressTitle5: '',
      address1: '',
      address2: '',
      address3: '',
      address4: '',
      address5: '',
      code: '',
      careOf: '',
      houseNo: '',
      flatName: '',
      flatNo: '',
      buildingName: '',
      codedAddressUncoded: '',
      personalAddressType: 0,
      personalAddressTypeDisplay: '',
      personalAddressTitle1: '',
      personalAddressTitle2: '',
      personalAddressTitle3: '',
      personalAddressTitle4: '',
      personalAddressTitle5: '',
      personalAddress1: '',
      personalAddress2: '',
      personalAddress3: '',
      personalAddress4: '',
      personalAddress5: '',
      personalCode: '',
      personalCareOf: '',
      personalHouseNo: '',
      personalFlatName: '',
      personalFlatNo: '',
      personalBuildingName: '',
      personalCodedAddressUncoded: '',
      recurring: false,
      openItem: false,
      exceptionFromPenalty: false,
      exempFromPenaltyDeadline: false,
      exempFromPenaltyDeadlineValue: null,
      exceptionFromVat: false,
      statementDeliveryByEmail: false,
      statementDeliveryBySms: false,
      comments: '',
      StatementDeliveryMethod: '',
      BookNo: '',
      WalkNo: '',
      PreviousCustkey: '',
      DepartmentCode: '',
      InfoFlag1Title: '',
      InfoFlag1: '',
      InfoFlag2Title: '',
      InfoFlag2: '',
      InfoFlag3Title: '',
      InfoFlag3: '',
      InfoFlag4Title: '',
      InfoFlag4: '',
      InfoFlag5Title: '',
      InfoFlag5: '',
      banksList: [],
      bankSelected: '',
      paymentTypeSelected: 0,
      BankAccountNo: '',
      DirectDepitAccountNo: '',
      DirectDepitAmount: 0,
      CheckNum: '',
      CheckNo: '',
      CheckDate: '',

      ShowAccounting: true,
      StatementDeliveryType: '',
      ShowPlots: false,
      Plots: [],
      PlotsCols: [],
      CommunicationsList: [],
      CommunicationsSelected: -1,
      CallTypesList: [],
      CallTypesSelected: -1,
      CallSubTypesList: [],
      CallSubTypesListTrimmed: [],
      CallSubTypesSelected: -1,
      CallDateFrom: null,
      CallDateTo: null,
      CallDateToDisabledDates: date => moment(date).isBefore(this.CallDateFrom),
      CallHistory: [],
      CallHistoryCols: [],
      Deposits: [],
      DepositsCols: [],
      DmCases: [],
      DmCasesCols: [],
      Operations: [],
      OperationsCols: [],
      DetailsChanges: [],
      DetailsChangesCols: [],
      Statements: [],
      StatementsCols: [],
      Transactions: [],
      TransactionsCols: [],
      DigitalSignature: [],
      DigitalSignatureCols: [],
      PortalLinks: [],
      PortalLinksCols: [],
      OwnedPropertiesCols: [],
      LinkedPropertiesCols: [],

      Sms: [],
      SmsCols: [],
      ConsentToReceiveSMS: false,
      ConsentToReceiveEmail: false,
      idType: '',
      idTypes: [{
        "value": -1,
        "text": "",
        "selected": true
      }],
      DsoContactId: '',
      StatementEmail: '',
      ContactConnectionDate: '',
      Language: '',

      callHistoryTotalRow: 0,
      callHistoryPageingoptions: { pageSize: 10, total: 0, page: 1 },
      depositsTotalRow: 0,
      depositsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      dmCasesTotalRow: 0,
      dmCasesPageingoptions: { pageSize: 10, total: 0, page: 1 },
      operationTotalRow: 0,
      operationPageingoptions: { pageSize: 10, total: 0, page: 1 },
      detailsChangesTotalRow: 0,
      detailsChangesPageingoptions: { pageSize: 10, total: 0, page: 1 },
      statementsTotalRow: 0,
      statementsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      transactionsTotalRow: 0,
      transactionsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      digitalSignatureTotalRow: 0,
      digitalSignaturePageingoptions: { pageSize: 10, total: 0, page: 1 },
      portalLinksTotalRow: 0,
      portalLinksPageingoptions: { pageSize: 10, total: 0, page: 1 },
      smsTotalRow: 0,
      smsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      ownedPropertiesPageingoptions: { pageSize: 10, total: 0, page: 1 },
      OwnedProperties: [],
      ownedPropertiesTotalRow: 0,
      linkedPropertiesPageingoptions: { pageSize: 10, total: 0, page: 1 },
      LinkedProperties: [],
      linkedPropertiesTotalRow: 0,

      accountNo: -1,
      loadingElements: {
        accountDtls: false,
        custDetailsLookUps: false,
        callSubTypes: false,
        callHistory: false,
        apps: false,
        customerDeposits: false,
        customerDmCases: false,
        customerOperations: false,
        customerTransactions: false,
        customerStatements: false,
        customerDetailsChanges: false,
        customerSms: false,
        customerPortalLinks: false,
        customerDigitalSignature: false,
        ownedProperties: false,
        otherTab: false,
        customFields: false,
      },
      bankSelectedDisplay: '',
      paymentTypeSelectedDisplay: '',
    }
  },
  created() {
    this.CUSTKEY = this.$route.params.CUSTKEY;

    if (!this.CUSTKEY)
      this.$router.push('/login');

    this.fillGridColumns();
    this.$material.locale.dateFormat = 'dd/MM/yyyy';

    this.tabs = [
      {
        id: "general",
        show: true,
        ...this.enqIcons.general,
      },
      {
        id: "details",
        show: true,
        ...this.enqIcons.details,
      },
      {
        id: "postaladdress",
        label: this.$t("enquiriesCustomerDetails.postaladdress"),
        show: true,
        icon: this.enqIcons.address.icon,
      },
      {
        id: "other",
        label: this.$t("enquiriesCustomerDetails.other"),
        show: true,
        icon: this.enqIcons.dots.icon,
      },
      {
        id: "applications",
        show: true,
        ...this.enqIcons.applications
      },
      {
        id: "ownedProperties",
        show: true,
        label: this.$removeAccents(this.$t('enquiriesCustomerDetails.ownedProp')),
        icon: this.enqIcons.property.icon,
      },
      {
        id: "eventLog",
        show: true,
        label: this.$removeAccents(this.$t('enquiriesCustomerDetails.eventLog')),
        icon: this.enqIcons.log.icon,
      },
      {
        id: "plots",
        show: false,
        ...this.enqIcons.plots
      },
      {
        id: "comments",
        show: true,
        ...this.enqIcons.comments,
      },
      {
        id: "callhst",
        show: true,
        ...this.enqIcons.history
      },
      {
        id: "deposits",
        show: true,
        ...this.enqIcons.deposits
      },
      {
        id: "dmCases",
        show: true,
        ...this.enqIcons.debtManagement
      },
      {
        id: "attachments",
        show: true,
        ...this.enqIcons.attachments
      },
      {
        id: "images",
        show: true,
        ...this.enqIcons.images
      },
      {
        id: "operations",
        show: true,
        label: this.$t('enquiriesCustomerDetails.operations'),
        icon: this.enqIcons.operations.icon
      },
      {
        id: "detailchanges",
        show: true,
        ...this.enqIcons.detailChanges
      },
      {
        id: "statements",
        show: true,
        ...this.enqIcons.statements
      },
      {
        id: "transactions",
        show: true,
        ...this.enqIcons.transactions
      },
      {
        id: "digitalSignature",
        label: this.$t("enquiriesCustomerDetails.digitalsign"),
        show: true,
        icon: this.enqIcons.signature.icon,
      },
      {
        id: "portalLinks",
        show: true,
        ...this.enqIcons.linkedAccounts
      },
      {
        id: "linkedProperties",
        show: true,
        ...this.enqIcons.linkedProperties
      },
      {
        id: "sms",
        show: true,
        ...this.enqIcons.sms
      },
      {
        id: "customFields",
        show: true,
        ...this.enqIcons.customFields
      },
      {
        id: "survaydata",
        label: this.$t("enquiriesCustomerDetails.survaydata"),
        show: false,
        icon: this.enqIcons.pie.icon
      },
      {
        id: "alert",
        label: this.$t("enquiriesCustomerDetails.alert"),
        show: false,
        icon: this.enqIcons.alert.icon
      },
    ];

    this.findDefaultTab();
  },
  mounted() {
    this.menuVisible = this.getFromLocal('_enquries_cust_det');
    this.getLookups();
  },
  computed: {
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function() {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    }
  },
  watch: {
    CallTypesSelected: function (val) {
      if (val == -1)
        this.CallSubTypesListTrimmed = this.CallSubTypesList;
      else
        this.CallSubTypesListTrimmed = this.CallSubTypesList.filter(l => l.typeId == this.CallTypesSelected);
        
      this.CallSubTypesSelected = -1;
      this.fillCallHistory();
    },
    CallSubTypesSelected: function (val) {
      this.fillCallHistory();
    },
    CommunicationsSelected: function (val) {
      this.fillCallHistory();
    },
    CallDateFrom: function (val) {
      if (moment(this.CallDateTo).isBefore(val))
        this.CallDateTo = null;

      this.fillCallHistory();
    },
    CallDateTo: function (val) {
      this.fillCallHistory();
    },
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        //case 'applications':
        //  this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
        //  this.$root.$emit(`refresh_data_grid:agreementsDataGrid`);
        //  break;

        case 'callhst':
          this.fillCallHistory();
          break;

        default:
         this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrl(val);      
    },
  },
  methods: {
    getLookups() {
      this.loadingElements.general = true;
      axios.post('/Enquiries/GetCustomerDetailsLookups', { Value: this.getLoginName() })
        .then(response => {
          if (response.status == 200) {
            this.billingGroupList = response.data.billingGroups;
            this.billGroup = this.billingGroupList == null ? '' : this.billingGroupList.length == 0 ? '' : this.billingGroupList[0]['groupId'];

            this.consumerTypeList = response.data.customerTypes;
            this.consumerType = this.consumerTypeList == null ? '' : this.consumerTypeList.length == 0 ? '' : this.consumerTypeList[0]['id'];

            this.getCustomerData();
            this.loadingElements.general = true;
          }
          else
            this.getDataFailed();
        })
        .catch(e => {
          this.getDataFailed(e);
          this.loadingElements.general = false;
        });
    },
    getCustomerData() {
      axios.get('/Enquiries2/GetAccountDetails?account=' + this.CUSTKEY)
        .then(response => {
          if (response.status == 200) {

            //console.log('response.data', response.data);
            //console.log('customer', response.data.customer);
            this.empName = response.data.stampUser;
            var _customer = response.data.customer;
            var _otherData = response.data.otherTabData;
            var _plots = response.data.plots;
            //var _sms = response.data.sms;
            var _languages = response.data.languageIds
            var _addressTypes = response.data.addressTypes;

            this.statementDeliveryTypes = response.data.deliveryMethods;
            this.statementDeliveryTypes.unshift({ value: -1, text: this.$t('enquiriesCustomerDetails.none'), selected: false });
            let stmDel = this.statementDeliveryTypes.filter(s => s.value == response.data.customer.statementDeliveryTypeId);

            if (stmDel && stmDel.length > 0)
              this.StatementDeliveryType = stmDel[0].text;
            else
              this.StatementDeliveryType = this.statementDeliveryTypes[0].text;

            let kk = this.StatementDeliveryType;
            if (response.data.customerIdTypes && response.data.customerIdTypes.length > 0)
              this.idTypes = response.data.customerIdTypes;
            else
              this.idTypes = [{
                "value": -1,
                "text": "",
                "selected": true
              }];

            this.customerId = _customer.customerId;
            this.accountType = AccountType[_customer.accountType];
            this.BillingGroupTitle = _customer.billingGroupTitle;
            this.billGroup = response.data.billingGroups.filter(b => b.selected == true)[0].text;
            this.consumerType = response.data.consumerTypes.filter(b => b.selected == true)[0].text;
            this.oldAccountNo = _customer.oldKey;
            this.accountStatus = _customer.accountStatus == CustomerAccountStatus.Active ? this.$t('enquiries.Active') : this.$t('enquiries.Closed');
            this.surname = _customer.surname;
            this.companyName = _customer.companyName;
            this.title = _customer.title;
            this.gender = CustomerGender[_customer.gender];
            this.firstName = _customer.fullName.replace(this.surname, '');
            this.telephoneNo = _customer.telNo;
            this.workTelephoneNo = _customer.workTelNo;
            this.comTelephoneNo = _customer.comTelNo;
            this.cellTelephoneNo = _customer.cellTelNo;
            this.noSms = _customer.noSms;
            this.compCellTelephoneNo = _customer.compCellTelephoneNo;
            this.compNoSms = _customer.compNoSms;
            this.custEmail = _customer.email;
            this.compFaxNo = _customer.compFaxNo;
            this.applicantName = _customer.applicantName;
            this.applicantTelephoneNo = _customer.applicantTelephoneNo;
            this.employer = _customer.employerName;
            this.employerTelephoneNo = _customer.employerTel;
            this.registrationNo = _customer.registrationNo;
            this.compEmail = _customer.compEmail;
            this.faxNo = _customer.faxNo;
            this.taxNo = _customer.taxNo;
            this.addEmail = _customer.addEmail;
            this.idNo = _customer.idNo;
            this.idType = this.idTypes.filter(i => i.selected == true)[0].text; //_customer.idTypeId
            this.pin = _customer.pin;
            this.birthDate = this.$options.filters.formatDateDDMMYYY(_customer.birthDate);
            this.birthDateChecked = _customer.birthDateChecked;
            this.addressType = _customer.addressType;
            this.addressTypeDisplay = _addressTypes.filter(a => a.value == this.addressType)[0].text;
            this.addressTitle1 = _customer.address1Title;
            this.addressTitle2 = _customer.address2Title;
            this.addressTitle3 = _customer.address3Title;
            this.addressTitle4 = _customer.address4Title;
            this.addressTitle5 = _customer.address5Title;
            this.address1 = _customer.address1;
            this.address2 = _customer.address2;
            this.address3 = _customer.address3;
            this.address4 = _customer.address4;
            this.address5 = _customer.address5;
            this.code = _customer.code;
            this.careOf = _customer.careOf;
            this.houseNo = _customer.houseNo;
            this.flatName = _customer.flatName;
            this.flatNo = _customer.flatName;
            this.buildingName = _customer.buildingName;
            this.codedAddressUncoded = _customer.codedAddressUncoded;
            this.personalAddressType = _customer.personalAddressType;
            this.personalAddressTypeDisplay = _addressTypes.filter(a => a.value == this.personalAddressType)[0].text
            this.personalAddressTitle1 = _customer.personalAddress1Title;
            this.personalAddressTitle2 = _customer.personalAddress2Title;
            this.personalAddressTitle3 = _customer.personalAddress3Title;
            this.personalAddressTitle4 = _customer.personalAddress4Title;
            this.personalAddressTitle5 = _customer.personalAddress5Title;
            this.personalAddress1 = _customer.personalAddress1;
            this.personalAddress2 = _customer.personalAddress2;
            this.personalAddress3 = _customer.personalAddress3;
            this.personalAddress4 = _customer.personalAddress4;
            this.personalAddress5 = _customer.personalAddress5;
            this.personalCode = _customer.personalCode;
            this.personalCareOf = _customer.personalCareOf;
            this.personalHouseNo = _customer.personalHouseNo;
            this.personalFlatName = _customer.personalFlatName;
            this.personalFlatNo = _customer.personalFlatNo;
            this.personalBuildingName = _customer.personalBuildingName;
            this.personalCodedAddressUncoded = _customer.personalCodedAddressUncoded;
            this.recurring = _customer.recurring;
            this.openItem = _customer.openItem;
            this.exceptionFromPenalty = _customer.exceptionFromPenalty;
            this.exempFromPenaltyDeadline = _customer.exempFromPenaltyDeadline;
            this.exempFromPenaltyDeadlineValue = this.$options.filters.formatDateDDMMYYY(_customer.exempFromPenaltyDeadlineValue);
            this.exceptionFromVat = _customer.exceptionFromVat;
            this.statementDeliveryByEmail = _customer.statementDeliveryByEmail;
            this.statementDeliveryBySms = _customer.statementDeliveryBySms;
            this.comments = _customer.comments;
            this.ShowAccounting = _customer.showAccounting;
            this.ConsentToReceiveEmail = _customer.consentReceiveEmail;
            this.ConsentToReceiveSMS = _customer.consentReceiveSms;
            this.DsoContactId = _customer.dsoContactId;
            this.statementEmail = _customer.statementEmail;
            this.ContactConnectionDate = this.$options.filters.formatDateDDMMYYY(_customer.contractConnDts);

            if (!response.data.customer.languageId)
              response.data.customer.languageId = 0;

            this.Language = _languages.filter(l => l.value == response.data.customer.languageId)[0].text;

            // Plots
            this.tabs.filter(a => a.id == 'plots')[0].show = this.ShowPlots;

            this.Plots = _plots;
            ////////////////////////////////////

            // Call History
            if (response.data.callHistoryLookups) {

              this.CallDateFrom = this.$options.filters.formatDateDDMMYYY(response.data.callHistoryLookups.dateFrom);
              this.CallDateTo = this.$options.filters.formatDateDDMMYYY(response.data.callHistoryLookups.dateTo);
            }

            this.fillCallAllTypes(this.CallTypesSelected);

            //this.fillCallHistory();
            ////////////////////////////////////

            if (_customer.showUnallocatedAmount)
              this.TransactionsCols.push({ dataField: 'unAllocatedAmountStr', caption: this.$t('enquiriesCustomerDetails.unAllocated') });
            ////////////////////////////////////

            
            this.getAllData();
          }
          else {
            console.log('Status != 200');
            this.noAccountFound();
          }
        })
        .catch(e => {
          this.noAccountFound(e.response.data);
        })
        .finally(() => {
          this.loadingElements.general = false;
          this.$forceUpdate();
        });
    },
    noAccountFound(e) {
      if (!e)
        e = 'No Such Account';

      this.$oldAlertMsg(e, 4);
      this.$forceUpdate();

      setTimeout(() => {
        this.$router.push('/login');
      }, 10000);
    },
    getAllData() {
      this.getOtherTabDetails();
      this.fillDeposits();
      this.fillDmCases();
      this.fillOperations();
      this.fillDetailsChanges();
      this.fillStatements();
      this.fillTransactions();
      this.fillDigitalSignature();
      this.fillPortalLinks();
      this.fillSms();
      this.fillOwnedProperties();
      this.fillLinkedProperties();
    },
    getOtherTabDetails() {
      this.loadingElements.otherTab = true;
      axios.get('/Enquiries2/GetOtherTabDetails?account=' + this.CUSTKEY )
        .then(response => {
          //console.log("resp", response)
          if (response.status == 200) {
            this.StatementDeliveryMethod = response.data.walkRoute ? 'WalkRouteChecked' : response.data.groupAcc ? 'GroupAccChecked' : 'ReservedAccChecked';
            this.BookNo = response.data.bookNo;
            this.WalkNo = response.data.walkNo;
            this.PreviousCustkey = response.data.prevCustkey;
            this.DepartmentCode = response.data.departCode;
            this.InfoFlag1Title = response.data.flag1Title;
            this.InfoFlag2Title = response.data.flag2Title;
            this.InfoFlag3Title = response.data.flag3Title;
            this.InfoFlag4Title = response.data.flag4Title;
            this.InfoFlag5Title = response.data.flag5Title;
            this.InfoFlag1 = response.data.flag1;
            this.InfoFlag2 = response.data.flag2;
            this.InfoFlag3 = response.data.flag3;
            this.InfoFlag4 = response.data.flag4;
            this.InfoFlag5 = response.data.flag5;

            this.banksList = response.data.banksListDataSource;
            this.bankSelected = response.data.bankSelected ?? '';
            this.bankSelectedDisplay = this.bankSelectedDisplay == null ? this.banksList.filter(b => b.id == this.bankSelected)[0].displayString : ''; 

            this.BankAccountNo = response.data.bankAcc;

            this.paymentTypeSelected = response.data.payType;
            this.paymentTypeSelectedDisplay = this.paymentTypeSelected == null ? '' : this.paymentType.filter(p => p.index == this.paymentTypeSelected)[0].Text;

            this.DirectDepitAccountNo = response.data.ddAccount;
            this.DirectDepitAmount = response.data.ddAmount;
            this.CheckNum = response.data.rdCheckNum;
            this.CheckNo = response.data.rdCheckNo;
            this.CheckDate = response.data.rdCheckDate;
          }
          else
            this.noAccountFound();
        })
        .catch(e => { this.noAccountFound(e); })
        .finally(() => {
          this.loadingElements.otherTab = false;
          //this.$forceUpdate();
        });
    },
    fillCallAllTypes() {
      axios.post('/Enquiries/GetCallAllTypes', { Value: -1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.CallTypesList = response.data.callTypes;
            this.CallTypesSelected = this.CallTypesList == null ? '' : this.CallTypesList.length == 0 ? '' : this.CallTypesList[0]['id'];

            this.CallSubTypesList = response.data.callSubTypes;
            this.CallSubTypesListTrimmed = this.CallSubTypesList;
            this.CallSubTypesSelected = this.CallSubTypesList == null ? '' : this.CallSubTypesList.length == 0 ? '' : this.CallSubTypesList[0]['id'];

            this.CommunicationsList = response.data.callCommunicationTypes;
            this.CommunicationsSelected = this.CommunicationsList == null ? '' : this.CommunicationsList.length == 0 ? '' : this.CommunicationsList[0]['id'];
          }
        })
        .catch(e => { return false; });
    },
    callHistoryPageChange(pInfo) {
      this.callHistoryPageingoptions.page = pInfo.pageNumber;
      this.callHistoryPageingoptions.pageSize = pInfo.pageSize;
      this.fillCallHistory();
    },
    fillCallHistory() {
      var parameters = {
        custkey: this.CUSTKEY,
        dateFrom: this.CallDateFrom,
        dateTo: this.CallDateTo,
        callType: this.CallTypesSelected,
        callSubType: this.CallSubTypesSelected,
        commType: this.CommunicationsSelected,
        Options: this.callHistoryPageingoptions
      };

      this.loadingElements.callhst = true;
      axios.post('/Enquiries/FillCallHistory', parameters)
        .then(response => {
          if (response.status == 200) {
            this.CallHistory = response.data.items;

            this.callHistoryTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.callhst = false);
    },

    fillGridColumns() {
      this.CallHistoryCols.push({ dataField: 'date', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.CallHistoryCols.push({ dataField: 'type', caption: this.$t('enquiriesCustomerDetails.type') });
      this.CallHistoryCols.push({ dataField: 'subType', caption: this.$t('enquiriesCustomerDetails.subType') });
      this.CallHistoryCols.push({ dataField: 'commType', caption: this.$t('enquiriesCustomerDetails.commType') });
      this.CallHistoryCols.push({ dataField: 'comment', caption: this.$t('enquiriesCustomerDetails.comment') });
      this.CallHistoryCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.CallHistoryCols.push({ dataField: 'moduleName', caption: this.$t('enquiriesCustomerDetails.app') });


      this.DepositsCols.push({ dataField: 'property', caption: this.$t('enquiriesCustomerDetails.property') });
      this.DepositsCols.push({ dataField: 'amount', caption: this.$t('enquiriesCustomerDetails.amount') });
      this.DepositsCols.push({ dataField: 'refunded', caption: this.$t('enquiriesCustomerDetails.refunded') });


      this.DmCasesCols.push({ dataField: 'caseId', caption: this.$t('enquiriesCustomerDetails.caseNo') });
      this.DmCasesCols.push({ dataField: 'status', caption: this.$t('enquiriesCustomerDetails.status') });
      this.DmCasesCols.push({ dataField: 'activityStage', caption: this.$t('enquiriesCustomerDetails.stage') });
      this.DmCasesCols.push({ dataField: 'openDate', caption: this.$t('enquiriesCustomerDetails.OpenDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });


      this.OperationsCols.push({ dataField: 'operation', caption: this.$t('enquiriesCustomerDetails.operation') });
      this.OperationsCols.push({ dataField: 'description', caption: this.$t('enquiriesCustomerDetails.description') });
      this.OperationsCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.OperationsCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });

      this.DetailsChangesCols.push({ dataField: 'field', caption: this.$t('enquiriesCustomerDetails.property') });
      this.DetailsChangesCols.push({ dataField: 'originalValue', caption: this.$t('enquiriesCustomerDetails.originalValue') });
      this.DetailsChangesCols.push({ dataField: 'newValue', caption: this.$t('enquiriesCustomerDetails.newValue') });
      this.DetailsChangesCols.push({ dataField: 'sourceId', caption: this.$t('enquiriesCustomerDetails.applicationNo') });
      this.DetailsChangesCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.DetailsChangesCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });


      this.StatementsCols.push({ dataField: 'custkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.StatementsCols.push({ dataField: 'accountName', caption: this.$t('enquiriesCustomerDetails.accountName') });
      this.StatementsCols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.StatementsCols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.StatementsCols.push({ dataField: 'paymentNo', caption: this.$t('enquiriesCustomerDetails.invoiceNo') });
      this.StatementsCols.push({ dataField: 'closingBalance', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.StatementsCols.push({ dataField: 'payBy', caption: this.$t('enquiriesCustomerDetails.payBy'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.StatementsCols.push({ dataField: 'emailSent', caption: this.$t('enquiriesCustomerDetails.emailSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.StatementsCols.push({ dataField: 'smsSent', caption: this.$t('enquiriesCustomerDetails.smsSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });


      this.TransactionsCols.push({ dataField: 'custkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.TransactionsCols.push({ dataField: 'accountName', caption: this.$t('enquiriesCustomerDetails.accountName') });
      this.TransactionsCols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.TransactionsCols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      this.TransactionsCols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      this.TransactionsCols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      this.TransactionsCols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      this.TransactionsCols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      this.TransactionsCols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      this.TransactionsCols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      this.TransactionsCols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      this.TransactionsCols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      this.TransactionsCols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.TransactionsCols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.TransactionsCols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.TransactionsCols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      this.TransactionsCols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      this.TransactionsCols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      this.TransactionsCols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      this.TransactionsCols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      this.TransactionsCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.TransactionsCols.push({ dataField: 'stampDate', caption: this.$t('enquiriesCustomerDetails.stampDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });


      this.DigitalSignatureCols.push({ dataField: 'sourceTypeS', caption: this.$t('enquiriesCustomerDetails.source') });
      this.DigitalSignatureCols.push({ dataField: 'sourceId', caption: this.$t('enquiriesCustomerDetails.sourceId') });
      this.DigitalSignatureCols.push({ dataField: 'sourceDetails', caption: this.$t('enquiriesCustomerDetails.sourceDetails') });
      this.DigitalSignatureCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.DigitalSignatureCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.DigitalSignatureCols.push({ dataField: 'fileName', caption: this.$t('enquiriesCustomerDetails.fileName') });


      this.PortalLinksCols.push({ dataField: 'linkedCustkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.PortalLinksCols.push({ dataField: 'name', caption: this.$t('enquiriesCustomerDetails.name') });


      this.SmsCols.push({ dataField: 'smsId', caption: this.$t('enquiriesCustomerDetails.id') });
      this.SmsCols.push({ dataField: 'sourceTypeText', caption: this.$t('enquiriesCustomerDetails.sourceType') });
      this.SmsCols.push({ dataField: 'address', caption: this.$t('enquiriesCustomerDetails.address') });
      this.SmsCols.push({ dataField: 'text', caption: this.$t('enquiriesCustomerDetails.text') });
      this.SmsCols.push({ dataField: 'statusText', caption: this.$t('enquiriesCustomerDetails.status') });
      this.SmsCols.push({ dataField: 'error', caption: this.$t('enquiriesCustomerDetails.error') });
      this.SmsCols.push({ dataField: 'processedDateTime', caption: this.$t('enquiriesCustomerDetails.processed'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.SmsCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.SmsCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });

      this.OwnedPropertiesCols.push({ dataField: 'ref', caption: this.$t('captureMR.propertyRef') });
      this.OwnedPropertiesCols.push({ dataField: 'share', caption: this.$t('enquiriesCustomerDetails.Share') });

      this.LinkedPropertiesCols.push({ dataField: 'ref', caption: this.$t('captureMR.propertyRef') });
      this.LinkedPropertiesCols.push({ dataField: 'share', caption: this.$t('enquiriesCustomerDetails.Share') });
    },

    depositsPageChange(pInfo) {
      this.depositsPageingoptions.page = pInfo.pageNumber;
      this.depositsPageingoptions.pageSize = pInfo.pageSize;
      this.fillDeposits();
    },
    fillDeposits() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.depositsPageingoptions
      }

      this.loadingElements.deposits = true;
      axios.post('/Enquiries/getCustomerDeposits', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Deposits = response.data.items;

            this.depositsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.loadingElements.deposits = false);
    },
    depositSelected(item) {
     //TBI download deposit
    },

    dmCasesPageChange(pInfo) {
      this.dmCasesPageingoptions.page = pInfo.pageNumber;
      this.dmCasesPageingoptions.pageSize = pInfo.pageSize;
      this.fillDmCases();
    },
    fillDmCases() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.dmCasesPageingoptions
      }

      this.loadingElements.dmCases = true;
      axios.post('/Enquiries/getCustomerDmCases', parameters)
        .then(response => {
          if (response.status == 200) {
            response.data.items.sort((a, b) => (a.caseId > b.caseId) ? -1 : 1);
            this.DmCases = response.data.items;

            this.dmCasesTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.loadingElements.dmCases = false);
    },
    dmSelected(item) {
      //TBI download deposit
    },

    operationPageChange(pInfo) {
      this.operationPageingoptions.page = pInfo.pageNumber;
      this.operationPageingoptions.pageSize = pInfo.pageSize;
      this.fillOperations();
    },
    fillOperations() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.operationPageingoptions
      }

      this.loadingElements.operations = true;
      axios.post('/Enquiries/getCustomerOperations', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Operations = response.data.items;

            this.operationTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.operations = false);
    },

    detailsChangesPageChange(pInfo) {
      this.detailsChangesPageingoptions.page = pInfo.pageNumber;
      this.detailsChangesPageingoptions.pageSize = pInfo.pageSize;
      this.fillDetailsChanges();
    },
    fillDetailsChanges() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.detailsChangesPageingoptions
      }

      this.loadingElements.detailchanges = true;
      axios.post('/Enquiries/getCustomerDetailsChanges', parameters)
        .then(response => {
          if (response.status == 200) {
            this.DetailsChanges = response.data.items;

            this.detailsChangesTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.detailchanges = false);
    },

    statementsPageChange(pInfo) {
      this.statementsPageingoptions.page = pInfo.pageNumber;
      this.statementsPageingoptions.pageSize = pInfo.pageSize;
      this.fillStatements();
    },
    fillStatements() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.statementsPageingoptions
      }

      this.loadingElements.statements = true;
      axios.post('/Enquiries/getCustomerStatements', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Statements = response.data.items;

            this.statementsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.loadingElements.statements = false);
    },

    transactionsPageChange(pInfo) {
      this.transactionsPageingoptions.page = pInfo.pageNumber;
      this.transactionsPageingoptions.pageSize = pInfo.pageSize;
      this.fillTransactions();
    },
    fillTransactions() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.transactionsPageingoptions
      }

      this.loadingElements.transactions = true;
      axios.post('/Enquiries/getCustomerTransactions', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Transactions = response.data.items;

            this.transactionsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.transactions = false);
    },

    digitalSignaturePageChange(pInfo) {
      this.digitalSignaturePageingoptions.page = pInfo.pageNumber;
      this.digitalSignaturePageingoptions.pageSize = pInfo.pageSize;
      this.fillDigitalSignature();
    },
    fillDigitalSignature() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.digitalSignaturePageingoptions
      }

      this.loadingElements.digitalSignature = true;
      axios.post('/Enquiries/getCustomerDigitalSignature', parameters)
        .then(response => {
          if (response.status == 200) {
            this.DigitalSignature = response.data.items;

            this.digitalSignatureTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.loadingElements.digitalSignature = false);
    },

    portalLinksPageChange(pInfo) {
      this.portalLinksPageingoptions.page = pInfo.pageNumber;
      this.portalLinksPageingoptions.pageSize = pInfo.pageSize;
      this.fillPortalLinks();
    },
    fillPortalLinks() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.portalLinksPageingoptions
      }

      this.loadingElements.portalLinks = true;
      axios.post('/Enquiries/getCustomerPortalLinks', parameters)
        .then(response => {
          if (response.status == 200) {
            this.PortalLinks = response.data.items;

            this.portalLinksTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.portalLinks = false);
    },

    smsPageChange(pInfo) {
      this.smsPageingoptions.page = pInfo.pageNumber;
      this.smsPageingoptions.pageSize = pInfo.pageSize;
      this.fillSms();
    },
    fillSms() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.smsPageingoptions
      }

      this.loadingElements.sms = true;
      axios.post('/Enquiries/getCustomerSms', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Sms = response.data.items;

            this.smsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.sms = false);
    },

    ownedPropertiesPageChange(pInfo) {
      this.ownedPropertiesPageingoptions.page = pInfo.pageNumber;
      this.ownedPropertiesPageingoptions.pageSize = pInfo.pageSize;
      this.fillOwnedProperties();
    },
    fillOwnedProperties() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.ownedPropertiesPageingoptions
      }

      this.loadingElements.ownedProperties = true;
      axios.post('/Enquiries/getOwnedProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.OwnedProperties = response.data.items;

            this.ownedPropertiesTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.loadingElements.ownedProperties = false);
    },

    linkedPropertiesPageChange(pInfo) {
      this.linkedPropertiesPageingoptions.page = pInfo.pageNumber;
      this.linkedPropertiesPageingoptions.pageSize = pInfo.pageSize;
      this.linkedPropertySelected();
    },
    fillLinkedProperties() {
      var parameters = {
        custkey: this.CUSTKEY,
        loginEmail: this.getLoginName(),
        Options: this.linkedPropertiesPageingoptions
      }

      this.loadingElements.linkedProperties = true;
      axios.post('/Enquiries/getPortalRepresentedLinkedProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.LinkedProperties = response.data.items;

            this.linkedPropertiesTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  })
        .finally(() => this.loadingElements.linkedProperties = false);
    },

    propertySelected(item) {
      this.openNewWindow(`/propertyDetails/${item.data.propertyId}`);
    },

    showOnMap(item) {
      const url1 = 'https://www.google.com/maps/search/';
      let url2
      if (item == 'mailAddr') {
        url2 = this.replaceSpaceWithPlus(this.address1 + ',' + this.address2 + ',' + this.address3 + ',' + this.address4);
      }
      else if (item == 'personalAddr') {
        url2 = this.replaceSpaceWithPlus(this.personalAddress1 + ',' + this.personalAddress2 + ',' + this.personalAddress3 + ',' + this.personalAddress4);
      }

      if (url2)
        window.open(url1 + url2);
    },
    replaceSpaceWithPlus(str) {
      return str.replaceAll(' ', '+');
    },
    getIcon(item) {
      return this.tabs.filter(t => t.id == item)[0].icon;
    },
  }
}

